<script lang="ts">
    import { storeLanguage, lang_fr } from "../scripts/store";
</script>
    
<style lang="scss">

    .homedescription {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        background: linear-gradient(to bottom right, $color_white, $color_grey);
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__text {
            text-align: center;
            width: 85%;
            font-size: 20px;
            margin: 60px 0 0 0;
        }
        &__jb {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            margin: 60px 0 60px 0;
            &__photo {
                background-image: url("../assets/images/homedescription-jb.jpeg");
                background-size: contain;
                width: 75px;
                height: 75px;
                border-radius: 50%;
            }
            &__text {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                text-align: center;
                color: $color_primary;
                margin: 15px 0 0 0;
            }
        }
    }

    @include large {
        .homedescription {
            &__jb {
                flex-direction: row;
                &__photo {
                    transition: all 0.5s;
                    box-sizing: border-box;
                    border: solid 1px $color_primary;
                    &:hover {
                        border: solid 1px $color_orange;
                        transform: scale(1.2);
                    }
                }
                &__text {
                    transition: all 1s;
                    text-align: left;
                    margin: 0 0 0 30px;
                    &:hover {
                        color: $color_orange;
                    }
                }
            }
        }
    }

</style>

<div class="homedescription">
    <div class="bloc homedescription__bloc">
        <div class="homedescription__text">
            {#if ($storeLanguage == $lang_fr)}
            Le collectif API Thinking regroupe toutes celles et ceux qui œuvrent au quotidien autour des API et qui partagent un point commun : avoir déjà initié une démarche d'API ou avoir pour projet de le faire. Rejoignez notre démarche lancée en mai 2020 par Julien Bichon qui réunit aujourd'hui environ 200 membres.
            {:else}
            The API Thinking collective brings together all those who work on APIs on a daily basis and who share a common point: having already initiated an API approach or planning to do so. Join our initiative launched in May 2020 by Julien Bichon, which today brings together around 200 members.
            {/if}
        </div>
        <div class="homedescription__text">
            {#if ($storeLanguage == $lang_fr)}
            Ensemble, imaginons une meilleure qualité des APIs, ensemble créons et consommons des APIs éco-responsables, ensemble profitons des expériences de chacun en terme de gouvernance et d'architecture, ensemble, sécurisons davantage nos APIs, ensemble réfléchissons aux fonctionnalités idéales d'un portail ! Rejoignez-nous.
            {:else}
            Together, let's imagine a better quality of APIs, together let's create and consume eco-responsible APIs, together let's take advantage of each other's experiences in terms of governance and architecture, together, let's make our APIs more secure, together let's think about the ideal functionalities of a portal! Join us.
            {/if}
        </div>
        <a class="homedescription__jb" href="https://www.linkedin.com/in/julien-bichon-api/" target="_blank">
            <div class="homedescription__jb__photo"></div>
            <div class="homedescription__jb__text">
                Julien Bichon<br>
                {#if ($storeLanguage == $lang_fr)}
                Fondateur du collectif API Thinking    
                {:else}
                Founder of the API Thinking collective
                {/if}
            </div>
        </a>    
    </div>
</div>
